import { WidgetStorageId } from '@/types/enums/WidgetStorageId';
import storage from 'local-storage-fallback';

const VITE_MELINGO_QUERY_URL = import.meta.env.VITE_MELINGO_QUERY_URL;

const useMelingo = () => {
  const queryCall = async (body: any = {}) => {
    console.debug('useMelingo queryCall', body);

    const hostId =
      storage.getItem(WidgetStorageId.HostId) ?? window.TravelOneConfig.hostId;
    const widgetLanguage =
      storage.getItem(WidgetStorageId.WidgetLanguage) ?? 'en';

    return fetch(`${VITE_MELINGO_QUERY_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'host-id': hostId,
        'Content-Language': widgetLanguage
      },
      body: body ? JSON.stringify(body) : undefined
    });
  };

  return { queryCall };
};

export default useMelingo;
